export enum RegisteredType {
  AppCheckIn = 0,
  DirectRentalRented = 1,
  BookedRentalRented = 2,
  DirectRentalReturn = 3,
  BookedRentalReturn = 4,
  MultipleCheckIn = 5
}
